<div class="setion scrollbar" id="scrollcustom" *ngIf="data?.type != 'terms'">
  <div class="head">
    <h4>{{ (currentUser.obfuscated && operator.obfuscateName) ? operator.obfuscateName : operator.name }} EULA</h4>
  </div>

  <div class="names">
    <div class="adres">

      <div *ngIf="sanitizedPdfUrl" class="pdf-container">
        <app-eula-introduction *ngIf="this.currentUser?.obfuscated" [operator] = this.siteUrl></app-eula-introduction>
        <iframe [src]="sanitizedPdfUrl" width="100%" height="100%" seamless="seamless" [style]="currentUser?.obfuscated ? 'height:calc(100vh - 460px); cursor: pointer;' : 'cursor: pointer;'" title="eula"></iframe>
      </div>

      <div *ngIf="operator?.operatorKey === OPERATORS.OSK">
        <iframe src="../../../../../assets/files/OSK-EULA.pdf#toolbar=0&navpanes=0&scrollbar=0" width="100%" height="100%"
          seamless="seamless" style="cursor: pointer;" title="eula">
        </iframe>
      </div>
    </div>
  </div>
</div>

<div class="loader-container" *ngIf="loading">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div class="setion scrollbar terms-scrollbar" [class.expanded]="expandNote" id="scrollcustom" *ngIf="data?.type === 'terms' && !loading">
  <div class="names">
    <div class="adres">
      <div style="padding: 2%;" class="pdf-container">
        <iframe [src]="safePdfUrl" width="100%" height="100%" seamless="seamless" style="cursor: pointer;" title="terms"></iframe>
      </div>
    </div>
  </div>
</div>

<div class="thanks" *ngIf="data?.type === 'eula'">
  <button mat-flat-button color="primary" class="delete" (keydown)="onKeyPress($event, 1)" (click)="onKeyPress($event, 1)"
    style="margin: 30px 0 0 0; background-color: #1059a9; color: #fff">
    Ok, Thanks
  </button>
</div>

<div class="thanks" fxLayoutGap="15px" *ngIf="data?.type === 'save'">
  <button style="border: 1px solid rgba(0,0,0,.12);"
   (keydown)="onKeyPress($event, 1)" (click)="onKeyPress($event, 1)" class="custom-button">
    Close</button>
    <button mat-flat-button color="primary" class="delete" (click)="savePdf(operator?.operatorKey)"
    style="margin: 30px 0 0 0; background-color: #1059a9; color: #fff">
    Save
  </button>
</div>

<div *ngIf="data?.type === 'terms' && !loading" style="margin: 2%; display: table;">
  <mat-accordion>
    <mat-expansion-panel (opened)="expandNote = true" (closed)="expandNote = false">
      <mat-expansion-panel-header>
        <mat-panel-title>By clicking <b>"I Accept"</b> or using the Platform, you acknowledge that:</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="tou-note">
        <ul>
          <li>You have read and understood these terms</li>
          <li>You agree to be bound by these terms and all Policies</li>
          <li>You have had the opportunity to seek independent legal advice</li>
          <li>Your electronic acceptance constitutes a legally binding signature</li>
        </ul>
        <p>
          By registering an account on the Platform, you agree to be bound by these terms and all Eartheye Space
          Policies applicable to the use of the Platform or the Services available at
          <a href="https://eartheye.space/" target="_blank">https://tasking.eartheye.space.</a> The Effective Date is the date of the effecting of the “I Accept” button as described above, or the date of your signature of these Terms of Use.
        </p>
      </div>

    </mat-expansion-panel>
  </mat-accordion>
</div>

<div class="thanks" fxLayoutGap="15px" *ngIf="data?.type === 'terms'">
  <button style="border: 1px solid rgba(0,0,0,.12);"
   (click)="onNoClick(0)" class="custom-button">
    Decline</button>
    <button mat-flat-button color="primary" class="delete" (click)="onNoClick(1)"
    style="margin: 30px 0 0 0; background-color: #1059a9; color: #fff">
    Accept
  </button>
  <button mat-flat-button color="primary" class="delete" (click)="saveTermPdf()"
    style="margin: 30px 0 0 0; background-color: #1059a9; color: #fff">
    Save
  </button>
</div>